import { useEffect } from 'react';

const STORAGE_KEY = 'chaosScore';
const MAX_LEVEL = 10;

function getChaosLevel(): number {
  if (typeof window === 'undefined') return 0;
  const score = parseInt(localStorage.getItem(STORAGE_KEY) || '0', 10);
  return Math.min(MAX_LEVEL, Math.floor(score / 10));
}

function syncChaosToBody(): void {
  document.body.dataset.chaos = String(getChaosLevel());
}

/**
 * Tracks how much chaos the user has earned through play.
 * chaosScore (0–100) in localStorage, chaosLevel (0–10) applied to body[data-chaos].
 * CSS reads data-chaos to progressively escalate visual effects.
 */
export function useChaos() {
  useEffect(() => {
    syncChaosToBody();
  }, []);

  const incrementChaos = (points = 5) => {
    const current = parseInt(localStorage.getItem(STORAGE_KEY) || '0', 10);
    const next = Math.min(100, current + points);
    localStorage.setItem(STORAGE_KEY, String(next));
    syncChaosToBody();
  };

  return { chaosLevel: getChaosLevel(), incrementChaos };
}
